import { Injectable } from '@angular/core';
import { CustomerGroup } from '../shared/message/CustomerGroup';
import { URLS } from '../constant/interface';

import { Observable, of } from 'rxjs';

import { catchError } from 'rxjs/operators';

import { _HttpClient, ModalHelper } from '@delon/theme';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  // constructor() {}

  constructor(private http: _HttpClient, private modal: ModalHelper) {}

  public getCustomGroups(): Observable<CustomerGroup[]> {
    return this.http
      .get<CustomerGroup[]>(URLS.customerGroup.url)
      .pipe(catchError(this.handleError<CustomerGroup[]>('getCustomGroups', [])));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      // console.log(`${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }
}
